import { ENTITY_TYPES } from "@/other/constants/OtherKeys.jsx";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";
import { createChecklist, type Checklist } from "@/react/components/entityViews/checklist/types";
import type { CheckGridOverviewItem, CheckGridSubjectType } from "../types";

export function subjectTypeFromOverview(grid: Pick<CheckGridOverviewItem, "task_id" | "client_id" | "resource_id" | "subject_type">): CheckGridSubjectType {
  if (grid.task_id) return "task";
  if (grid.client_id) return "client";
  if (grid.resource_id) return "resource";
  return grid.subject_type;
}

export function hostEntityIdFromOverview(grid: Pick<CheckGridOverviewItem, "task_id" | "client_id" | "resource_id">): number | null {
  return grid.task_id ?? grid.client_id ?? grid.resource_id ?? null;
}

export function storeKeyForSubjectType(subjectType: CheckGridSubjectType): string {
  if (subjectType === "task") return STORE_KEYS.taskStore;
  if (subjectType === "client") return STORE_KEYS.clientStore;
  return STORE_KEYS.resourceStore;
}

export function entityTypeForSubjectType(subjectType: CheckGridSubjectType): string {
  if (subjectType === "task") return ENTITY_TYPES.TASK;
  if (subjectType === "client") return ENTITY_TYPES.CLIENT;
  return ENTITY_TYPES.RESOURCE;
}

export function entityTypeLabel(grid: Pick<CheckGridOverviewItem, "task_id" | "client_id" | "resource_id" | "subject_type">): string {
  const type = entityTypeForSubjectType(subjectTypeFromOverview(grid));
  return type.charAt(0).toUpperCase() + type.slice(1);
}

/** Checklist stub for nudge / grant checks, built from a list row. */
export function checklistRecordFromOverview(grid: CheckGridOverviewItem): Checklist {
  return createChecklist({
    id: grid.id,
    title: grid.name,
    canEdit: grid.can_edit_grant,
    canView: grid.can_view_grant,
    assignedBoardUsers: grid.assigned_boarduser_ids ?? [],
    taskId: grid.task_id ?? null,
    clientId: grid.client_id ?? null,
    resourceId: grid.resource_id ?? null,
    archived: Boolean(grid.archived)
  });
}
